import React from 'react';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import UpdateButton from "./UpdateButton";

export default () => (
    <Card style={{ margin: '2em' }}>
        <CardHeader title="Welcome to the administration" />
        <CardText>Διαχειριστικο συστήμα</CardText>
        <CardText></CardText>
        <UpdateButton />
        <CardText></CardText>
    </Card>
);



// WEBPACK FOOTER //
// ./src/custom/Dashboard.js